import { replace } from 'connected-react-router';

import {
  goToMenuViaSlug,
  goToOrderSettingsViaSlug
} from 'locations/actions/locations';

const handleSingleLocationFlow = ({
  online_ordering_location,
  requested_fulfillment_is_asap,
  location_slug
}) => async dispatch => {
  const BROWSER_HISTORY_METHOD = replace;
  if (online_ordering_location && requested_fulfillment_is_asap) {
    await dispatch(goToMenuViaSlug(location_slug, BROWSER_HISTORY_METHOD));
  } else {
    await dispatch(
      goToOrderSettingsViaSlug(location_slug, BROWSER_HISTORY_METHOD)
    );
  }
};

export default handleSingleLocationFlow;
